const STORAGE_KEY = "tnv.financeiro.dashboard.periodo";

export type FinanceiroDashboardPeriodo = {
  dataInicio: string;
  dataFim: string;
};

export function writeFinanceiroDashboardPeriodo(
  periodo: FinanceiroDashboardPeriodo,
): void {
  if (typeof window === "undefined") return;
  if (!periodo.dataInicio?.trim() || !periodo.dataFim?.trim()) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(periodo));
  } catch {
    /* ignore */
  }
}

export function readFinanceiroDashboardPeriodo(): FinanceiroDashboardPeriodo | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FinanceiroDashboardPeriodo;
    if (!parsed?.dataInicio?.trim() || !parsed?.dataFim?.trim()) return null;
    return {
      dataInicio: parsed.dataInicio.trim(),
      dataFim: parsed.dataFim.trim(),
    };
  } catch {
    return null;
  }
}

export function buildLancamentosVendasPath(
  periodo?: FinanceiroDashboardPeriodo | null,
): string {
  const base = "/loja/financeiro/lancamentos-vendas";
  if (!periodo?.dataInicio || !periodo?.dataFim) return base;
  const qs = new URLSearchParams({
    dataInicio: periodo.dataInicio,
    dataFim: periodo.dataFim,
  });
  return `${base}?${qs.toString()}`;
}
